import { IStudentView, IPermissionFilter, IGraduationPrognosis, IForecastAggregatedMinimalInputFilterType, IForecastAggregatedMinimal, IForecastAggregatedOverview, IHighSchoolAdmissionStats, IHighSchoolExaminationStats, ICourseResultStatsData } from '../../types/types';

import { graphQLPost } from '../../utilities';

export default class Statistics {
    static async getGraduationPrognosis(input: { classId: number }): Promise<IGraduationPrognosis> {
        try {
            const response = await graphQLPost(`query GetStudentView($classId: Int) {
                studentView(classId: $classId) {
                    firstName lastName
                    gender
                    socialSecurityNumber
                    programType
                    studentForecastView {
                        grade courseName courseDisplayName points prognosis courseType startDate endDate schoolYear prevPrognosis
                    }
                    programName
                } 
                programMandatoryCourses(classId: $classId) {
                    id
                    code
                    name
                    type
                    courseDisplayName
                    courseType
                    courseFilterMask
                }
            }`, { classId: input.classId });

            return response/*.slice(0, 142)*/ as IGraduationPrognosis;
        }
        catch(e) {
            console.error(e);
            throw("Fel vid begäran av examenprognos...");
        }
    }

    static async GetForecastAggregatedMinimal(filter: IForecastAggregatedMinimalInputFilterType): Promise<IForecastAggregatedMinimal[]> {
        try {
            const response = await graphQLPost(`query GetForecastAggregatedMinimal($input: ForecastAggregatedMinimalInputFilterType) {
                forecastAggregatedMinimal(filter: $input) 
                {
                  courseName 
                  courseDisplayName 
                  prognosis_1 
                  prognosis_2 
                  prognosis_3 
                  prognosis_4 
                  prognosis_5
                }
              }`, { input: filter });

            return response.forecastAggregatedMinimal as IForecastAggregatedMinimal[];
        }
        catch(e) {
            console.error(e);
            throw("Fel vid begäran av aggregerad data...");
        }
    }
    
    static async GetForecastAggregatedOverview(filter: IForecastAggregatedMinimalInputFilterType): Promise<IForecastAggregatedOverview[]> {
        try {
            const response = await graphQLPost(`query GetForecastAggregatedOverview($input: ForecastAggregatedMinimalInputFilterType) {
                forecastAggregatedOverview(filter: $input) 
                {
                  courseName 
                  courseDisplayName 
                  gender
                  prognosis_1 
                  prognosis_2 
                  prognosis_3 
                  prognosis_4 
                  prognosis_5
                }
              }`, { input: filter });

            return response.forecastAggregatedOverview as IForecastAggregatedOverview[];
        }
        catch(e) {
            console.error(e);
            throw("Fel vid begäran av aggregerad data...");
        }
    }
    
    static async GetHighSchoolAdmissionStats(to: Date, schoolIds: number[]): Promise<IHighSchoolAdmissionStats[]> {
        try {
            const response = await graphQLPost(`
                query GetHighSchoolAdmissionStats($to: DateTime, $schoolIds: [Int]) {
                    highSchoolAdmissionStats(to: $to, schoolIds: $schoolIds) {
                        gender,
                        className,
                        classId,
                        schoolId,
                        schoolName,
                        year,
                        coreSubjectsCompleted,
                        basicAdmissionApproved,
                        universityProgramApproved,
                        allGoals,
                        goodGrades,
                        meritPoints
                    } 
                }`,
                { to: to.toDateString(), schoolIds: schoolIds });
            
            return response.highSchoolAdmissionStats as IHighSchoolAdmissionStats[];
        }
        catch(e) {
            console.error(e);
            throw("Fel vid begäran av statisk för gymnasiebehörighet...");
        }
    }
    
    static async GetHighSchoolExaminationStats(to: Date, schoolIds: number[]): Promise<IHighSchoolExaminationStats[]> {
        try {
            const response = await graphQLPost(`
                query GetHighSchoolExaminationStats($to: DateTime, $schoolIds: [Int]) {
                    highSchoolExaminationStats(to: $to, schoolIds: $schoolIds) {
                        gender,
                        className,
                        classId,
                        schoolName,
                        schoolId,
                        year,
                        program,
                        programType,
                        examination,
                        examinationProject,
                        meritValue,
                        coursePoints,
                        programPoints,
                        coursePointsTotal,
                        coreSubjectsCompleted
                    } 
                }`,
                { to: to.toDateString(), schoolIds: schoolIds });
            
            return response.highSchoolExaminationStats as IHighSchoolExaminationStats[];
        }
        catch(e) {
            console.error(e);
            throw("Fel vid begäran av examenstatistik...");
        }
    }
    
    static async GetCourseResultStats(from: Date, to: Date, schoolIds: number[]): Promise<ICourseResultStatsData[]> {
        try {
            const response = await graphQLPost(`
                query GetCourseResultStats($from: DateTime,$to: DateTime,$schools: [Int]) {
                    courseResultStats(from: $from,to: $to,schoolIds: $schools) {
                        gender,
                        className,
                        classId,
                        courseId,
                        courseCode,
                        courseName,
                        schoolName,
                        schoolId,
                        year,
                        program,
                        status
                    } 
                }`,
                { from: from.toDateString(), to: to.toDateString(), schools: schoolIds });
            
            return response.courseResultStats as ICourseResultStatsData[];
        }
        catch(e) {
            console.error(e);
            throw("Fel vid begäran av ämnesstatistik...");
        }
    }
}